import React from 'react';

import styles from '../Sections.module.scss';

export interface SubSectionState {
  isExist: boolean;
  isCompleted: boolean;
}

interface SubSectionProps {
  state: SubSectionState;
}

const SubSection = ({ state, children }: React.PropsWithChildren<SubSectionProps>) => {
  return state.isExist ? <div className={styles.subSectionContainer}>{children}</div> : <></>;
};

export default SubSection;
